import React from "react";
import { X, Phone, Mail } from "lucide-react";

export function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-[#0A0A0A] rounded-xl p-8 max-w-lg w-full relative border-2 border-[#FF7954]">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-[#FF7954] hover:text-[#FCDEBE] transition-colors"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-bold text-white text-center mb-8">
          Contactez-nous
        </h2>

        <div className="space-y-6 flex flex-col items-center">
          <a
            href="tel:+33681128810"
            className="flex items-center text-white hover:text-[#FF7954] transition-colors"
          >
            <Phone size={24} className="mr-4" />
            06 81 12 88 10
          </a>

          <a
            href="mailto:sci.plr.60@sfr.fr?subject=Demande%20d'information%20PLR%20Park&body=Bonjour%2C%0A%0AJe%20souhaite%20obtenir%20des%20informations%20sur%20vos%20services%20de%20parking.%0A%0ACordialement%2C"
            className="flex items-center text-white hover:text-[#FF7954] transition-colors"
          >
            <Mail size={20} className="mr-3" />
            sci.plr.60@sfr.fr
          </a>
        </div>
      </div>
    </div>
  );
}
